import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';

import {Button, Card, DatePicker, Form, notification} from 'antd';

import {getPurchaseOrder, submitPurchaseOrder} from './actions';
import InputContact from "../common/InputContact";
import {getDescriptionFromError} from "../utils/errors";
import {formItemLayout} from "../utils/style";
import {decodeParams} from "../utils/params";

const FormItem = Form.Item;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class SubmitPurchaseOrderForm extends Component {
  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.purchaseId !== this.props.match.params.purchaseId) {
      this._load();
    }
  }

  _load = () => {
    const {purchaseId} = decodeParams(this.props.match.params);
    this.props.getPurchaseOrder({purchaseId});
  };

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {purchaseId} = decodeParams(this.props.match.params);
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.submitPurchaseOrder({...values, purchaseId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading, purchaseOrder} = this.props;
    const {submittedDate, requestedDeliveryDate, submittedTo} = purchaseOrder;
    return (
      <Card title="Submit Purchase Order">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Purchase Order"
          >
            {`${purchaseOrder.supplierName} - ${purchaseOrder.status} (${purchaseOrder.modifiedAt})`}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Submitted Date"
          >
            {getFieldDecorator('submittedDate', {
              initialValue: submittedDate && moment(submittedDate),
              rules: [
                { required: true, message: 'Please input your Submitted Date' },
              ]
            })(
              <DatePicker />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Requested Delivery Date"
          >
            {getFieldDecorator('requestedDeliveryDate', {
              initialValue: requestedDeliveryDate && moment(requestedDeliveryDate),
              rules: [
                { required: true, message: 'Please input your Requested Delivery Date' },
              ]
            })(
              <DatePicker />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Submitted To"
          >
            {getFieldDecorator('submittedTo', {
              initialValue: submittedTo || null
            })(
              <InputContact key={`submit-${purchaseOrder.purchaseId}`}/>
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Submit Purchase Order
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

SubmitPurchaseOrderForm.propTypes = {
  form: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  dispensaryId: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  submitPurchaseOrder: PropTypes.func.isRequired,
  getPurchaseOrder: PropTypes.func.isRequired,
  purchaseOrder: PropTypes.object.isRequired,
};

const SubmitPurchaseOrderPage = Form.create()(SubmitPurchaseOrderForm);

const mapStateToProps = state => ({
  dispensaryId: state.dispensary.selectedDispensaryId,
  loading: state.purchaseOrder.purchaseOrderLoading || state.purchaseOrder.submitPurchaseOrderLoading,
  purchaseOrder: state.purchaseOrder.purchaseOrder || {},
});

const mapDispatchToProps = dispatch => ({
  submitPurchaseOrder: payload => (dispatch(submitPurchaseOrder(payload))),
  getPurchaseOrder: payload => (dispatch(getPurchaseOrder(payload))),
});

export default connect(mapStateToProps, mapDispatchToProps)(SubmitPurchaseOrderPage);


// WEBPACK FOOTER //
// ./src/PurchaseOrder/SubmitPurchaseOrderPage.js